;(function ($, window) {
  'use strict'

  // setup a shared namespace, if needed
  window.GCO = window.GCO || {}

  window.GCO.counter = (function () {
    function init () {
      // kick off here
      $('#counter').countdown({
        timestamp: (new Date()).getTime() + 8 * 10 * 60 * 60 * 1000
      })
    }

    return {
      init: init
    }
  }())

  $(document).ready(GCO.counter.init)
}(jQuery, window))
